module.exports = __webpack_public_path__ + "img/load.7b79b3a9.gif";